import { create } from 'zustand';
import { loginStudent } from '../api';

const useAuthStore = create((set) => ({
  user: null,
  token: null,
  loading: false,
  error: null,

  init() {
    const token = localStorage.getItem('studentToken');
    const user = localStorage.getItem('studentUser');
    if (token && user) {
      set({ token, user: JSON.parse(user) });
    }
  },

  async login({ login, password }) {
    set({ loading: true, error: null });
    try {
      const data = await loginStudent({ login, password });
      set({ user: { studentId: data.studentId, fullName: data.fullName, group: data.group, groups: data.groups }, token: data.token, loading: false });
      localStorage.setItem('studentToken', data.token);
      localStorage.setItem('studentUser', JSON.stringify({ studentId: data.studentId, fullName: data.fullName, group: data.group, groups: data.groups }));
      return true;
    } catch (e) {
      set({ error: e.message, loading: false });
      return false;
    }
  },

  logout() {
    set({ user: null, token: null });
    localStorage.removeItem('studentToken');
    localStorage.removeItem('studentUser');
  },
}));

export default useAuthStore; 